import Vue from 'vue';
import VTooltip from 'v-tooltip';

import {
    prependImageDest,
    countCharacters,
    truncStr,
    generateId,
    result,
} from '@util';
import { fromEvent } from 'rxjs';
import { map, filter, startWith } from 'rxjs/operators';

import { DEFAULT_SVG_VIEWBOX } from '@consts';

import { getJoinedClassList } from '@/utils/dashboard';

Vue.directive('img-prepend', {
    bind: (el, binding) => {
        el.src = prependImageDest(binding.value);
    },
});

Vue.directive('tooltip', VTooltip.VTooltip);

Vue.directive(
    'maxchars',
    (() => {
        let _handlers = {};

        const _gt = R.flip(R.gt);

        return {
            bind: (el, binding, vnode) => {
                let {
                    value,
                    modifiers: { counter, charCounter },
                } = binding;
                counter = counter || countCharacters;
                const maxChars = value || Number.POSITIVE_INFINITY;
                const handlerId = generateId();

                const subscription = fromEvent(el, 'input')
                    .pipe(
                        startWith('init'),
                        map(() => el.value),
                        filter(R.compose(_gt(maxChars), counter)),
                        map((value) => truncStr(value, maxChars, charCounter))
                    )
                    .subscribe((value) => {
                        el.value = value;
                        vnode.elm.dispatchEvent(new CustomEvent('input'));
                    });

                _handlers = R.assoc(handlerId, subscription, _handlers);
                el.dataset.handlerId = handlerId;
            },
            unbind(el) {
                const id = el.dataset.handlerId;
                result('unsubscribe', R.propOr({}, id, _handlers));
                _handlers = R.dissoc(id, _handlers);
                delete el.dataset.handlerId;
            },
        };
    })()
);

var opacityFunc = ({ classList }, { value }) => {
    if (!value) {
        classList.remove('opacity-mask');
    } else {
        classList.add('opacity-mask');
    }
};

Vue.directive('opacity-mask', {
    bind: opacityFunc,
    update: opacityFunc,
});

const viewBoxFunc = (el) => el.setAttribute('viewBox', DEFAULT_SVG_VIEWBOX);

Vue.directive('view-box', {
    bind: viewBoxFunc,
    update: viewBoxFunc,
});

const _grayFunc = (el, { value }) => {
    const { classList } = el;

    if (value) {
        classList.add('svg-gray-scale');
    } else {
        classList.remove('svg-gray-scale');
    }
};

Vue.directive('fill-gray', {
    bind: _grayFunc,
    update: _grayFunc,
});

Vue.directive('mouse-inside', {
    bind: function (el, binding) {
        const {
            onMouseenter = R.identity,
            onMouseleave = R.identity,
            excludes = [],
        } = binding.value;

        const intersection = R.intersection([...excludes, 'ant']);

        el.addEventListener('mouseenter', onMouseenter);
        el.addEventListener('mouseleave', function (e) {
            if (intersection(getJoinedClassList(e)).length) {
                return;
            }

            onMouseleave(e);
        });
    },
    unbind: function (el) {
        el.onMouseenter = null;
        el.onMouseleave = null;
    },
});
